var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthWrongBase',[_vm._v(" Lo sentimos, pero has superado el número máximo de intentos de acceso permitidos. Por favor, inténtalo de nuevo dentro de una hora ")])}
var staticRenderFns = []

export { render, staticRenderFns }